import * as types from '../constants/actionTypes';
import initialState from '../reducers/initialState';

export default function weekApprovalUiReducer(state = initialState.weekApprovalUi, action) {
  let newState = state;

  switch (action.type) {
    case types.TOGGLE_MY_PROJECT_OPEN: {
      let newMyProjectOpen = state.myProjectOpen;
      newMyProjectOpen[action.projectKey] = !newMyProjectOpen[action.projectKey];
      newState = Object.assign({}, state, {
        myProjectOpen: newMyProjectOpen
      });
      return newState;
    }
    case types.TOGGLE_OTHER_PROJECT_OPEN: {
      let newOtherProjectOpen = state.otherProjectOpen;
      newOtherProjectOpen[action.projectKey] = !newOtherProjectOpen[action.projectKey];
      newState = Object.assign({}, state, {
        otherProjectOpen: newOtherProjectOpen
      });
      return newState;
    }
    case types.TOGGLE_MY_TASK_OPEN: {
      let newMyTaskOpen = state.myTaskOpen;
      if(newMyTaskOpen[action.projectKey] === undefined) {
        newMyTaskOpen[action.projectKey] = [];
      }
      newMyTaskOpen[action.projectKey][action.taskKey] = !newMyTaskOpen[action.projectKey][action.taskKey];
      newState = Object.assign({}, state, {
        myTaskOpen: newMyTaskOpen
      });
      return newState;
    }
    case types.TOGGLE_OTHER_TASK_OPEN: {
      let newOtherTaskOpen = state.otherTaskOpen;
      if(newOtherTaskOpen[action.projectKey] === undefined) {
        newOtherTaskOpen[action.projectKey] = [];
      }
      newOtherTaskOpen[action.projectKey][action.taskKey] = !newOtherTaskOpen[action.projectKey][action.taskKey];
      newState = Object.assign({}, state, {
        otherTaskOpen: newOtherTaskOpen
      });
      return newState;
    }
    case types.UNFOLD_MY_PROJECT: {
      let newMyProjectOpen = state.myProjectOpen;
      newMyProjectOpen[action.projectKey] = true;
      newState = Object.assign({}, state, {
        myProjectOpen: newMyProjectOpen
      });
      return newState;
    }
    case types.UNFOLD_OTHER_PROJECT: {
      let newOtherProjectOpen = state.otherProjectOpen;
      newOtherProjectOpen[action.projectKey] = true;
      newState = Object.assign({}, state, {
        otherProjectOpen: newOtherProjectOpen
      });
      return newState;
    }
    case types.UNFOLD_MY_TASK: {
      let newMyTaskOpen = state.myTaskOpen;
      if(newMyTaskOpen[action.projectKey] === undefined) {
        newMyTaskOpen[action.projectKey] = [];
      }
      newMyTaskOpen[action.projectKey][action.taskKey] = true;
      newState = Object.assign({}, state, {
        myTaskOpen: newMyTaskOpen
      });
      return newState;
    }
    case types.UNFOLD_OTHER_TASK: {
      let newOtherTaskOpen = state.otherTaskOpen;
      if(newOtherTaskOpen[action.projectKey] === undefined) {
        newOtherTaskOpen[action.projectKey] = [];
      }
      newOtherTaskOpen[action.projectKey][action.taskKey] = true;
      newState = Object.assign({}, state, {
        otherTaskOpen: newOtherTaskOpen
      });
      return newState;
    }
    case types.FOLD_MY_PROJECT: {
      let newMyProjectOpen = state.myProjectOpen;
      newMyProjectOpen[action.projectKey] = false;
      newState = Object.assign({}, state, {
        myProjectOpen: newMyProjectOpen
      });
      return newState;
    }
    case types.FOLD_OTHER_PROJECT: {
      let newOtherProjectOpen = state.otherProjectOpen;
      newOtherProjectOpen[action.projectKey] = false;
      newState = Object.assign({}, state, {
        otherProjectOpen: newOtherProjectOpen
      });
      return newState;
    }
    case types.FOLD_MY_TASK: {
      let newMyTaskOpen = state.myTaskOpen;
      if(newMyTaskOpen[action.projectKey] === undefined) {
        newMyTaskOpen[action.projectKey] = [];
      }
      newMyTaskOpen[action.projectKey][action.taskKey] = false;
      newState = Object.assign({}, state, {
        myTaskOpen: newMyTaskOpen
      });
      return newState;
    }
    case types.FOLD_OTHER_TASK: {
      let newOtherTaskOpen = state.otherTaskOpen;
      if(newOtherTaskOpen[action.projectKey] === undefined) {
        newOtherTaskOpen[action.projectKey] = [];
      }
      newOtherTaskOpen[action.projectKey][action.taskKey] = false;
      newState = Object.assign({}, state, {
        otherTaskOpen: newOtherTaskOpen
      });
      return newState;
    }
    case types.RESET_MY_PROJECT_OPEN: {
      newState = Object.assign({}, state, {
        myProjectOpen: []
      });
      return newState;
    }
    case types.RESET_OTHER_PROJECT_OPEN: {
      newState = Object.assign({}, state, {
        otherProjectOpen: []
      });
      return newState;
    }
    case types.RESET_MY_TASK_OPEN: {
      newState = Object.assign({}, state, {
        myTaskOpen: []
      });
      return newState;
    }
    case types.RESET_OTHER_TASK_OPEN: {
      newState = Object.assign({}, state, {
        otherTaskOpen: []
      });
      return newState;
    }
    case types.SET_CURRENT_APPROVAL_WEEK: {
      newState = Object.assign({}, state, {
        currentWeek: action.week
      });
      return newState;
    }
    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/reducers/weekApprovalUiReducer.js
 **/